var map = {
	"./corn_leaf_opacity_map.jpg": 9221,
	"./cotton_leaf_opacity_map.jpg": 4887,
	"./cucumber_leaf_opacity_map.jpg": 4927,
	"./lettuce_leaf_opacity_map.jpg": 1269,
	"./peanut_leaf_opacity_map.jpg": 6858,
	"./potato_leaf_opacity_map.jpg": 2204,
	"./soy_leaf_opacity_map.jpg": 9443,
	"./tomato_leaf_opacity_map.jpg": 2191
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3313;